import React from 'react'
import { Box, Container, Divider, Grid, Link, Typography } from '@mui/material'
import FooterCol1 from '../submodules/FooterCol1';
import FooterCol2 from '../submodules/FooterCol2';
import FooterCol3 from '../submodules/FooterCol3';
import FooterCol4 from '../submodules/FooterCol4';
import Copyright from '../submodules/Copyright';
import SiteSearch from '../modules/SiteSearch';
import SocialMedia from '../modules/SocialMedia';
import Accessibility from '../submodules/Accessibility';

const Footer = (props) => {

  return (
    <Box>
      <Divider sx={{my: 3,}}/>
      <Container maxWidth="xl">
        <Box sx={{alignItems: "center", display: "flex",}}>
          <Link href="/" sx={{alignItems: "center", display: "flex", borderBottom: '1px solid transparent', transition: '.05s ease all', '&:hover': { borderBottom: '1px solid #b71c1c', transition: '.05s ease all', }}}>
            <Box
              alt="Personal Architect Logo"
              component="img"
              loading="lazy"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/logos/primary/personal-architect-horizontal.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/logos/primary/personal-architect-horizontal.svg"
              }
              sx={{height: 36.15, width: 220,}}
            />
          </Link>
        </Box>
        <Typography>Personal Architect is cloud-based home design software that runs anywhere. Start your project for free today.</Typography>
        <SocialMedia flexDirection="row" />
        <Box sx={{marginTop: 1,}}>
          <SiteSearch />
        </Box>
        <Box sx={{pt: 2,}}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <FooterCol1 />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <FooterCol2 />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <FooterCol3 />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <FooterCol4 />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "center", my: 2}}>
        <Accessibility />
      </Box>
      <Copyright />
    </Box>
  )
}

export default Footer